
import RequestAbstract from "../abstract";

export default class Chains extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/crypto/chains";
    }
}

